import React from 'react';
import { GridItem } from '@chakra-ui/react';
import { Control } from 'react-hook-form';
import { Contribution } from 'types/contribution';
import { DateField, FormSubtitle } from 'app/components/Core';
import { ContributionFormData } from '../types';

interface DateFieldsProps {
  control: Control<ContributionFormData>;
  contribution?: Contribution;
}

export const DateFields: React.FC<DateFieldsProps> = ({
  control,
  contribution,
}) => (
  <>
    <GridItem w="full" gridColumn="1 / 4">
      <FormSubtitle containerStyleProps={{ width: 'full', pt: 4 }}>
        Date
      </FormSubtitle>
    </GridItem>
    <GridItem>
      <DateField
        name="date.date"
        label="Date"
        control={control}
        isRequired={Boolean(contribution?.date?.date)}
        shouldSaveInvalidDate
        dataTestId="Date"
      />
    </GridItem>
    <GridItem />
    <GridItem />
  </>
);
